import config from "@/config";
import store from "@/store";

const NavUtil = {
  toVapor(): void {
    const event = store.state.EventModule?.event;
    const url = !event?.practice ? `${config.vaporUrl}/event/${event?.id}` : `${config.vaporUrl}/virtual_practice`;
    window.open(url, "_self");
  },
};

export default NavUtil;
